interface StepFourProps {
  nextStep: () => void;
  acceptedDiscount: boolean;
  discountedPrice: number;
  discountedCurrency?: string;
  cycleDuration?: number;
}

const getCycleDurationQualifier = (cycleDuration?: number) => {
  if (cycleDuration === 1) return 'mes';
  if (cycleDuration === 3) return 'trimestral';
  return 'semestral';
};

const formatPrice = (price: number, currency = '$') => {
  return `${currency}${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const StepFour = ({ 
  nextStep, 
  acceptedDiscount, 
  discountedPrice, 
  discountedCurrency, 
  cycleDuration 
}: StepFourProps) => (
  <div>
    <div className="mb-3">
      <img 
        src="https://cache.beholos.com/img/holos/plans/cancel-banner-v2.webp" 
        alt="Gracias" 
        className="w-full mb-2 rounded-lg" 
      />
    </div>
    
    <div className="font-bold text-lg text-black leading-tight mb-3">
      {acceptedDiscount ? '¡Excelentes noticias!' : '¡Qué pena verte partir!'}
    </div>
    
    <div className="text-sm text-black mb-2">
      {acceptedDiscount
        ? 'Estamos muy contentos de que hayas decidido quedarte con nosotros y trabajaremos arduamente para dar seguimiento a tus comentarios y asegurarnos de que estés satisfecho con tu decisión.'
        : 'Lamentamos que hayas cancelado tu plan, ¡esperamos que vuelvas pronto!'
      }
    </div>
    
    {acceptedDiscount && (
      <div className="text-sm text-black mb-2">
        Actualizamos tu suscripción, por lo que se te cobrará{' '}
        {formatPrice(discountedPrice, discountedCurrency)}/{getCycleDurationQualifier(cycleDuration)}{' '}
        en tu nuevo ciclo.
      </div>
    )}
    
    {acceptedDiscount ? (
      <a 
        href="/user/clases" 
        className="block w-full bg-black text-white py-3 px-4 rounded-lg font-semibold uppercase text-center hover:bg-gray-800 mt-3"
      >
        Comenzar buscando una clase
      </a>
    ) : (
      <button 
        className="w-full bg-black text-white py-3 px-4 rounded-lg font-semibold uppercase hover:bg-gray-800 mt-3 cursor-pointer" 
        onClick={nextStep}
      >
        Cerrar
      </button>
    )}
    
    <div className="text-xs text-gray-500 mt-2">
      ¿Tienes alguna pregunta? Ponte en contacto con nuestro equipo de soporte{' '}
      <a className="font-bold text-gray-500 hover:text-gray-700" href="mailto:contacto@beholos.com">
        Aquí.
      </a>
    </div>
  </div>
);